import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { RadioModel } from "../../../shared/model/radio.model";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackInfo } from "../../../shared/service/journey/tracks/model/track-info";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { NifCountriesService } from "../../../shared/service/nif-countries/nif-countries.service";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { IncomeWealthService } from "../../service/income-wealth.service";

@Component({
  selector: "app-tax-residency-country",
  templateUrl: "./tax-residency-country.component.html",
  styleUrls: ["./tax-residency-country.component.scss"],
})
export class TaxResidencyCountryComponent
  extends DefaultPageComponent
  implements OnInit
{
  selectedItem = "";
  selectedName = "";
  taxCountry = new Array<RadioModel>();
  textSearch: string;
  fieldSearch = "value";
  headerId = "income-tax-residency-country";
  titlePage = "Renda e patrimônio";
  buttonEnable = false;
  @ViewChild("content") content: ElementRef;
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  idLabelTaxResidenceCountry = "idLabelTaxResidenceCountry";
  idInputTaxResidenceCountry = "idInputTaxResidenceCountry";
  idRadioTaxResidenceCountry = "idRadioTaxResidenceCountry";
  idButtonTaxResidenceCountry = "idButtonTaxResidenceCountry";
  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    public analycticsNativeService: AnalycticsNativeService,
    public incomeWealthService: IncomeWealthService,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private nifCountriesService: NifCountriesService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.CountryNif);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainCountry();
    this.editFieldInvest(
      "pais_residencia_fiscal_sigla",
      "taxResidence",
      "income"
    );
    this.incomeWealthService.setInitialDataTaxResidence({
      ...this.journeyService.registratioJourney.data.incomeEquity,
    });
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const hasPageNif =
      track.track.findIndex((page: TrackInfo) => page.pageId === "income-nif") >
      -1;

    this.startStage = "1";
    this.endStage = hasPageNif ? "3" : "1";

    if (track.getName() === TrackTypes.UPDATE_REGISTRATION) {
      this.startStage = "";
      this.endStage = "";
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.textSearch = "";
    this.taxCountry = this.orderList(this.taxCountry, this.selectedItem);
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.taxResidencyCountry;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathPaisResidenciaFiscal,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathPaisResidenciaFiscal,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    const trackName = this.journeyService.selectedTrack.getName();
    const track = this.journeyService.selectedTrack;
    const hasPageNif =
      track.track.findIndex(
        (page: TrackInfo) =>
          page.pageId === "income-nif" || page.pageId === "nif"
      ) > -1;

    this.sendAnalyticsFirstView = true;
    this.incomeWealthService.setTaxResidence(this.selectedItem);
    this.incomeWealthService.setTaxResidenceName(this.selectedName);

    if (hasPageNif) {
      if (
        this.selectedItem === "BR" ||
        this.selectedItem === "BRA" ||
        this.selectedItem === "648"
      ) {
        this.resetNumberNif();

        if (trackName === TrackTypes.UPDATE_REGISTRATION) {
          this.router.navigateForward(["data", "client-data"]);
        } else {
          this.endJourney();
        }
      } else {
        this.nextPage();
      }
    } else {
      this.endJourney();
    }
  }

  resetNumberNif() {
    this.incomeWealthService.setNif(undefined);
    this.incomeWealthService.setDateTaxResidency(undefined);
  }

  changeItem($event: string) {
    this.selectedItem = $event;
    this.taxCountry = this.orderList(this.taxCountry, this.selectedItem);

    if (
      this.journeyService.registratioJourney.data.incomeEquity?.taxResidence
    ) {
      this.resetNumberNif();
    }
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.taxResidencyCountry,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getDomainCountry() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          const result = [];
          dominios.forEach((item) => {
            const notDuplicated =
              result.findIndex((redItem) => {
                return item.value === redItem.value;
              }) > -1;
            if (!notDuplicated) {
              result.push(item);
            }
          });

          this.taxCountry = this.orderList(
            result,
            this.journeyService.registratioJourney.data.incomeEquity
              ?.taxResidence
          );
          this.showRetry = false;
          this.loading = false;
          this.nifCountriesService.setListNifCountries(this.taxCountry);
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.loading = false;
          this.showRetry = true;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.loading = false;
        this.showRetry = true;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== "") {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter((value) => value.key === selectedItem),
        ...dataOrder.filter((value) => value.key !== selectedItem),
      ];
    }
    return data;
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.incomeEquity.taxResidence) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.incomeEquity.taxResidence;
      this.selectedName =
        this.journeyService.registratioJourney.data.incomeEquity.taxResidenceName;
    }
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
